import React from "react";
import Link from "gatsby-link";

import "../assets/css/main.css";

import Header from "../components/Header";
import About from "../components/About";
import Resume from "../components/Resume";
import Portfolio from "../components/Portfolio";
// import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import Organizations from "../components/Organizations";


const IndexPage = () => (
  <div>
    <Header />
    <About />
    <Resume />
    <Portfolio />
    <Organizations />
    <Footer />
  </div>
);

export default IndexPage;
